import { t } from "../services/utils";
export default {
  NEW_CLIENTS: 1,
  EXISTING_CLIENTS: 2,
  BOTH_NEW_AND_EXISTING: 3
};